/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".top[_ngcontent-%COMP%]{font-size:18px;font-weight:600;margin-bottom:5px}.middle[_ngcontent-%COMP%]{font-size:14px;margin-bottom:0}.bottom[_ngcontent-%COMP%]{font-size:12px}"];
export { styles as styles };

